import { render, staticRenderFns } from "./FeesAndCharges.vue?vue&type=template&id=36f183d5"
import script from "./FeesAndCharges.vue?vue&type=script&lang=js"
export * from "./FeesAndCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports